module.exports = __webpack_public_path__ + "static/2-005-915864c1cc4b0abf1909bdda000ac2a8.jpg";